import { X } from "lucide-react";
import React from "react";

export interface RailViewHeaderProps {
	/** What the reader is looking at — "Graph". */
	title: string;
	/** The question the view belongs to, shown as one muted line beneath. */
	aboutLabel?: string;
	/** Back to the thread. The close X does the same thing. */
	onBack: () => void;
}

/**
 * The chrome above an in-rail view (DOP-492).
 *
 * A rail has ONE body. When an answer's Graph takes it, the thread — and with
 * it every clue about which answer this is — goes off screen, so the header
 * has to carry both the way back and the question it belongs to. The Audit Log
 * grows its own version of this row inside `TracePanel` (`variant="embedded"`)
 * rather than being wrapped in this one: its header already owns a step badge
 * and a copy control, and two stacked headers is not a design.
 */
const RailViewHeader: React.FC<RailViewHeaderProps> = ({
	title,
	aboutLabel,
	onBack,
}) => (
	<div className="rail-view-header">
		<div className="rail-view-header-row">
			<button type="button" className="rail-view-back" onClick={onBack}>
				<span aria-hidden="true">&lsaquo;</span> Thread
			</button>
			<span className="rail-view-title">{title}</span>
			<button
				type="button"
				className="rail-view-close"
				onClick={onBack}
				title="Back to the thread"
				aria-label="Back to the thread"
			>
				<X className="rail-view-close-icon" />
			</button>
		</div>
		{aboutLabel && (
			<p className="rail-view-about">
				For the answer to &ldquo;{aboutLabel}&rdquo;
			</p>
		)}
	</div>
);

export default RailViewHeader;
